<template>
    <div style="width:100%;heigh:100%;" id="chechConf">
         <template v-if="showPage == 0">
             <div class="table_searchbar">
                <el-row >
                    <el-col :span="span">
                        <div class="" @keydown.enter="btnSearch()">
                        <span class="title">模板名称：</span>
                        <el-input size="small" style="max-width:180px" v-model="searchForm.name"   maxlength="16" placeholder="模板名称"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="span">
                        <div class="">
                            <span class="title">维修级别：</span>
                            <el-select size="small" style="max-width:180px;" v-model="searchForm.level" placeholder="维修级别"  >
                                <el-option v-for="item in levelOption" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>                     
                        </div>
                    </el-col>
                    <el-col :span="W?span:6">
                        <div class="">
                            <span class="title">设备类型：</span>
                            <el-select size="small" style="max-width:180px;" v-model="searchForm.deviceTypeId" placeholder="设备类型"  >
                                <el-option v-for="item in deviceType" :key="item.id" :label="item.deviceType" :value="item.id">
                                </el-option>
                            </el-select>                     
                        </div>
                    </el-col>
                    <el-col :span="W?(24-3*span):4">
                        <div style="text-align:right">
                            <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
                            <el-button size="mini" icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="table_common_operbar" >
                <el-row>
                    <el-button v-if="permission.btn_repairTemplate_add" icon="el-icon-plus" type="primary" size="small" @click="addWindowShow()">新增模板</el-button>
                    <el-button v-if="permission.btn_repairProblem_list"  type="primary" size="small" @click="showConfigDialog()">问题类型配置</el-button>
                </el-row>
            </div>
            <el-table :data="tableData" stripe style="width: 100%" class="deviceTable y_Public_table">
                <el-table-column prop="name" label="模板名称" min-width="160"></el-table-column>
                <el-table-column prop="deviceTypeId" label="设备类型" :formatter='parseDeviceType' min-width="110"></el-table-column>
                <el-table-column prop="wrongCode" label="故障代码"  min-width="110"></el-table-column>
                <el-table-column prop="level" label="使用级别" :formatter='parseLeve' min-width="110"></el-table-column>
                <el-table-column prop="gmtCreate" label="创建时间" :formatter='parseDate' ></el-table-column>
                <el-table-column label="操作" fixed="right" width="150px">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showViewDialog(scope.row)" size="small">查看</el-button>
                        <el-button type="text" @click="showEditDialog(scope.row)" size="small" v-if="permission.btn_repairTemplate_update">编辑</el-button>
                        <el-button type="text" @click="deleteConfig(scope.row)" size="small" v-if="permission.btn_repairTemplate_delete">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page" v-if="tableData.length > 0">
                <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
                <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                    <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage">
                    </el-pagination>
                </div>
            </div>
            <!-- 新增开始 -->
            <el-dialog title="新增维修模板" @close="cancelAddDialog"   :visible.sync="addDialogVisible" :width="span==5?'45%':'70%'" center :close-on-click-modal="false">
                <el-form :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="add_form">
                    <el-row :gutter="20" style="margin-bottom:0px">
                        <el-col :span="8">
                            <span class="titel">模板名称：</span>
                            <el-form-item prop="name" class="value" :rules="rules.name">
                                <el-input ref="focusinput" size="small" @keyup.native="$event.target.value = $event.target.value.replace(/^\s+|\s+$/gm,'')"  style="max-width:180px" v-model="addForm.name" maxlength="16" placeholder="模板名称" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <span class="titel">维修级别：</span>
                            <el-form-item class="value" prop="level" style="max-width:180px">
                                <el-select size="small"  v-model="addForm.level" placeholder="维修级别" style="display:block">
                                    <el-option v-for="item in levelOption" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <span class="titel">设备类型：</span>
                            <el-form-item class="value" prop="deviceTypeId" style="max-width:180px">
                                <el-select size="small"  v-model="addForm.deviceTypeId" placeholder="设备类型" style="display:block">
                                    <el-option v-for="item in deviceType" :key="item.id" :label="item.deviceType" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20"  style="margin-bottom:0px" >
                        <el-col :span="8">
                            <span class="titel">故障代码：</span>
                            <el-form-item  class="value" >
                                <el-input size="small" style="max-width:180px" v-model="addForm.wrongCode" maxlength="16" placeholder="故障代码" ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" style="margin-top:13px">
                        <el-col :span="24">
                            <span>问题描述：</span>
                            <!-- <el-input :autosize="{ minRows: 3, maxRows: 4}" type="textarea" size="small" maxlength="50" :show-word-limit='true'  v-model="addForm.description"></el-input> -->
                            <el-select class="problem" v-model="addForm.description" size="small">
                                <el-option v-for="item in descriptionTemps" :key="item.id" :value="item.value"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" >
                        <el-col :span="24">
                            <span>维修建议：</span>
                            <el-input :autosize="{ minRows: 3, maxRows: 4}" type="textarea" size="small" maxlength="50" :show-word-limit='true'  v-model="addForm.advice"></el-input>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" >
                        <el-col :span="24">
                            <span>备注：</span>
                            <el-input :autosize="{ minRows: 3, maxRows: 4}" type="textarea" size="small" maxlength="225" :show-word-limit='true'  v-model="addForm.remark"></el-input>
                        </el-col>
                    </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitAddDialog">添 加</el-button>
                    <el-button @click="cancelAddDialog">取 消</el-button>
                </span>
            </el-dialog>
            <!-- 新增结束 -->

            <!-- 编辑开始 -->
            <el-dialog title="编辑维修模板" @close="cancelEditDialog"  :visible.sync="editDialogVisible" :width="span==5?'45%':'64%'" center :close-on-click-modal="false">
                <el-form :model="addForm" :rules="rules" ref="editForm" style="width:100%;" class="add_form">
                    <el-row :gutter="20" style="margin-bottom:0px">
                        <el-col :span="8">
                            <span class="titel">模板名称：</span>
                            <el-form-item prop="name" class="value" :rules="rules.name">
                                <el-input size="small" style="max-width:180px" v-model="addForm.name" maxlength="16" placeholder="模板名称" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <span class="titel">维修级别：</span>
                            <el-form-item class="value" prop="level" style="max-width:180px">
                                <el-select size="small"  v-model="addForm.level" placeholder="维修级别" style="display:block">
                                    <el-option v-for="item in levelOption" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <span class="titel">设备类型：</span>
                            <el-form-item class="value" prop="deviceTypeId" style="max-width:180px">
                                <el-select size="small"  v-model="addForm.deviceTypeId" placeholder="设备类型" style="display:block">
                                    <el-option v-for="item in deviceType" :key="item.id" :label="item.deviceType" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20"  style="margin-bottom:0px">
                        <el-col :span="8">
                            <span class="titel">故障代码：</span>
                            <el-form-item  class="value" >
                                <el-input size="small" style="max-width:180px" v-model="addForm.wrongCode" maxlength="16" placeholder="故障代码" ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20"  style="margin-top:13px">
                        <el-col :span="24">
                            <span>问题描述：</span>
                            <!-- <el-input :autosize="{ minRows: 3, maxRows: 4}" type="textarea" size="small" maxlength="50" :show-word-limit='true'  v-model="addForm.description"></el-input> -->
                            <el-select class="problem" v-model="addForm.description" size="small">
                                <el-option v-for="item in descriptionTemps" :key="item.id" :value="item.value"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" >
                        <el-col :span="24">
                            <span>维修建议：</span>
                            <el-input :autosize="{ minRows: 3, maxRows: 4}" type="textarea" size="small" maxlength="50" :show-word-limit='true'  v-model="addForm.advice"></el-input>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" >
                        <el-col :span="24">
                            <span>备注：</span>
                            <el-input :autosize="{ minRows: 3, maxRows: 4}" type="textarea" size="small" maxlength="225" :show-word-limit='true'  v-model="addForm.remark"></el-input>
                        </el-col>
                    </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitEditDialog">保 存</el-button>
                    <el-button @click="cancelEditDialog">取 消</el-button>
                </span>
            </el-dialog>
            <!-- 编辑结束 -->

            <!-- 查看开始 -->
            <el-dialog title="查看维修模板" @close="cancelViewDialog"  :visible.sync="viewDialogVisible" :width="span==5?'45%':'64%'" center :close-on-click-modal="false">
                <el-form :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="add_form">
                    <el-row :gutter="20" style="margin-bottom:30px">
                        <el-col :span="8">
                            <span class="titel">模板名称：</span>
                            <span>{{addForm.name}}</span> 
                        </el-col>
                        <el-col :span="8">
                            <span class="titel">维修级别：</span>
                            <span>{{addForm.level}}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="titel">设备类型：</span>
                            <span>{{addForm.deviceTypeId}}</span>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" style="margin-bottom:30px">
                        <el-col :span="8">
                            <span class="titel">故障代码：</span>
                            <span>{{addForm.wrongCode}}</span> 
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" >
                        <el-col :span="24">
                            <span>问题描述：</span>
                            <!-- <el-input :autosize="{ minRows: 3, maxRows: 4}" type="textarea" size="small" maxlength="50"  :value="addForm.description"></el-input> -->
                             <span>{{addForm.description}}</span> 
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" >
                        <el-col :span="24">
                            <span>维修建议：</span>
                            <el-input :autosize="{ minRows: 3, maxRows: 4}" type="textarea" size="small" maxlength="50"  :value="addForm.advice"></el-input>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" >
                        <el-col :span="24">
                            <span>备注：</span>
                            <el-input :autosize="{ minRows: 3, maxRows: 4}" type="textarea" size="small" maxlength="50"  :value="addForm.remark"></el-input>
                        </el-col>
                    </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelViewDialog" type="primary">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 新增结束 --> 
         </template>
         <template v-if="showPage == 1">
            <ErrConf style="width:100%;heigh:100%;" ></ErrConf>
         </template>
    </div>
</template>

<script>
import ErrConf from './ErrConf'
export default {
    name: 'MaintainConf',
    components:{
        ErrConf
    },
	data () {
        return {
            TmouserShow:null,
            showPage:0,
            fristLoad:false,
            levelOption:[
                {label:'一级',value:1},
                {label:'二级',value:2},
                {label:'三级',value:3},
            ],
            deviceType:[
                {
                    id : 1,
                    name : '车床'
                },{
                    id : 2,
                    name : '铣床'
                },{
                    id : 3,
                    name : '加工中心'
                },{
                    id : 4,
                    name : '锯床'
                },{
                    id : 5,
                    name : '磨床'
                },{
                    id : 6,
                    name : '钻床'
                },{
                    id : 7,
                    name : '拉丝机'
                },{
                    id : 8,
                    name : '摇臂钻'
                },{
                    id : 9,
                    name : '焊机'
                },{
                    id : 10,
                    name : '攻丝机'
                },{
                    id : 11,
                    name : '刨床'
                },{
                    id : 12,
                    name : '剪板机'
                },{
                    id : 13,
                    name : '折弯机'
                },{
                    id : 14,
                    name : '喷砂机'
                },{
                    id : 16,
                    name : '水车式专机'
                },{
                    id : 15,
                    name : '其它'
                }
            ],
            W:false,
            btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
            searchFormTemp: '',//临时搜索数据
            searchForm:{
                level:null,
                name:'',
                deviceTypeId:null
            },
            addForm:{
                deviceTypeId: null,
                wrongCode: "",
                level: null,
                advice: "",
                name: "",
                description: "",
                remark: ""
            },
            descriptionTemps:[],
            tableData:[],
            tableCurrentPage:1,
            tableTotalPage:2,
            addDialogVisible:false,
            editDialogVisible:false,
            viewDialogVisible:false,
            data: {
				token: localStorage.getItem("token"),
            },
            rules:{
                name:[
                    { required: true, message: '请输入模板名称', trigger: 'blur' }
                ],
               
                level:[
                    {required: true, message: '请选择维修级别', trigger: 'blur'}
                ],
                deviceTypeId:[
                    {required: true, message: '请选择设备类型', trigger: 'blur'}
                ]
            },
            permission:JSON.parse(localStorage.getItem("permission"))
        }
    },
    mounted:function(){
        this.initTable();
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
         w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
        this.loadDeviceTypeList()
        this.loaddescriptionTemps()
        eventBus.$on("error-change",()=>{
            this.loaddescriptionTemps()
        })
    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    deactivated:function(){
        console.log("deactivated");
    },
    methods:{
        TmouseOver(ev) {
            console.log(ev)
            let offsetHeight = this.$refs.Tmover.offsetHeight
            let scrollHeight = this.$refs.Tmover.scrollHeight
            if(offsetHeight<scrollHeight){
                this.TmouserShow = ev
            }
            console.log(offsetHeight)
            console.log(scrollHeight)
        },
        Tonmouseout() {
            this.TmouserShow = null
        },
        showConfigDialog(){
            this.showPage=1
        },
        async loadDeviceTypeList(){
            let {data,code,msg,message}=await this.$RequestUtil.getAsync({ url: '/api/device/listDeviceType', type:'sync', params: {},})
            if(code==0){
                this.deviceType = data
            }else{
                this.$message.error(msg||message)
            }
        },
        async loaddescriptionTemps(){
            let {data,code,msg,message}=await this.$RequestUtil.getAsync({ url: '/api/repairProblemDefine/listRepairProblem', type:'sync', params: {},})
            if(code==0){
                this.descriptionTemps = data
                this.descriptionTemps.push({value:"其它"})
            }else{
                this.$message.error(msg||message)
            }
        },
        deleteConfig(rowData){
            this.$confirm('此操作将删除该维修模板, 删除后不可撤销，是否继续?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.post({
                    url: '/api/repairTemplate/deleteRepairTemplate',
                    type:'sync',
                    params: {
                        id:rowData.id
                    },
                    success: (res) => {
                        if(res.code != -1){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search(1);
                        }
                    }
                })
            })
        },
        parseDeviceType(rowData){
            let num = Number(rowData.deviceTypeId)
            let str = ''
            this.deviceType.forEach(item=>{
                if(item.id==num){
                    str = item.deviceType
                }
            })
            return str
        },
        parseLeve(rowData){
            let num = Number(rowData.level)
            let str = ''
            switch(num){
                case 1:
                str = '一级'
                break
                case 2:
                str = '二级'
                break
                case 3:
                str = '三级'
                break  
            }
            return str
        },
        cancelEditDialog(){
            this.editDialogVisible = false
            this.addForm = {
                deviceTypeId: null,
                wrongCode: "",
                level: null,
                advice: "",
                name: "",
                description: "",
                remark: ""
            }
        },
        cancelViewDialog(){
            this.viewDialogVisible = false
            this.addForm = {
                deviceTypeId: null,
                wrongCode: "",
                level: null,
                advice: "",
                name: "",
                description: "",
                remark: ""
            }
        },
        cancelAddDialog(){
            this.addDialogVisible = false
            this.addForm = {
                deviceTypeId: null,
                wrongCode: "",
                level: null,
                advice: "",
                name: "",
                description: "",
                remark: ""
            }
        },
        submitAddDialog(){
            this.$refs['addForm'].validate((valid) => {
                if(valid){
                    this.$RequestUtil.post({
                        url: '/api/repairTemplate/addRepairTemplate',
                        type:'sync',
                        params: this.addForm,
                        success:(res)=>{
                            if(res.code==0){
                                this.$message.success('添加成功')
                                this.addDialogVisible = false
                                this.initTable();
                                this.cancelAddDialog()
                            }else{
                                this.$message.error(res.message);
                            }
                        },
                    })
                }
            })
        },
        submitEditDialog(){
             this.$refs['editForm'].validate((valid) => {
                if(valid){
                    this.$RequestUtil.post({
                        url: '/api/repairTemplate/updateRepairTemplate',
                        type:'sync',
                        params: this.addForm,
                        success:(res)=>{
                            if(res.code==0){
                                this.$message.success('编辑成功')
                                this.editDialogVisible = false
                                this.initTable();
                                this.cancelEditDialog()
                            }else{
                                this.$message.error(res.message);
                            }
                        },
                    })  
                }
            })
        },
        btnSearch:function(){
            this.tableCurrentPage = 1;
            this.btnPressType = 1
            this.search();
        },
        clearSearch(){
            let form = this.searchForm;
            this.btnPressType = 2;
            form.name='';
            form.level=null;
            form.deviceTypeId = null
        },
        search:function(){
            let temp;
            switch (this.btnPressType) {
              case 1:
                temp = commonUtils.cloneObj(this.searchForm);
                this.searchFormTemp = commonUtils.cloneObj(temp);
                break;
              case 0:
                temp ={
                  name:'',
                  level:null,
                  deviceTypeId:null,
                };
                break;
              case 2:
                temp = this.searchFormTemp;
                break;
              case 3:
                temp = this.searchFormTemp;
                break;
            }
            this.$RequestUtil.get({
                url: '/api/repairTemplate/listRepairTemplate',
                type:'sync',
				params: {
                    pageNum:this.tableCurrentPage,
                    pageSize:10,
                    name:temp.name,
                    level:temp.level,
                    deviceTypeId:temp.deviceTypeId
                },
                success: (res) => {
                    if(res.msg == this.$Global.RESPONSE.SUCCESS){
                        this.tableData = res.data;
                        this.tableTotalPage = res.totalPages;
                        if(res.totalPages == 0&&this.fristLoad){
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad = true
                    }else{
                        this.$message.error(res.message||res.msg)
                    }
                    
                }
            }); 
        },
        pageChange:function(targetPage){
            this.tableCurrentPage = targetPage;
            this.btnPressType = 3;
            this.search();
        },
        initTable:function(){
            this.search();
        },
        addWindowShow:function(){
            this.addForm.description = this.descriptionTemps[0].value;
            this.addDialogVisible = true;
            setTimeout(()=>{
                this.$refs.focusinput.focus()
            },0)
        },
        showEditDialog:function(rowData){
            this.editDialogVisible = true;
            this.addForm.name=rowData.name
            this.addForm.deviceTypeId = rowData.deviceTypeId
            this.addForm.id=rowData.id
            this.addForm.level=rowData.level 
            this.addForm.wrongCode=rowData.wrongCode
            this.addForm.advice=rowData.advice
            this.addForm.description=rowData.description
            this.addForm.remark=rowData.remark
        },
        showViewDialog(rowData){
            this.viewDialogVisible = true;
            this.addForm.name=rowData.name
            this.addForm.deviceTypeId=this.parseDeviceType(rowData)
            this.addForm.id=rowData.id
            this.addForm.level=this.parseLeve(rowData)
            this.addForm.wrongCode=rowData.wrongCode
            this.addForm.advice=rowData.advice
            this.addForm.description=rowData.description
            this.addForm.remark=rowData.remark
        },
        viewDevice:function(rowData){
            this.viewDialogVisible = true;
        },
        parseDate:function(rowData){
            if(rowData.gmtCreate != null){
                let dateString = commonUtils.timestampToDate(rowData.gmtCreate,true);
                return dateString;
            }
        }
    }
}
</script>

<style scoped>
.delete{
    width: 18px;
    height: 19px;
    background-image:url('../../../static/img/del.png');
    cursor: pointer;
    background-repeat: no-repeat;
}
.delete:hover{

    background-image: url('../../../static/img/del-hover.png');
    background-repeat: no-repeat;
}
.table_searchbar .title11{
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}
.add_form .title{
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    display:inline-block;
    text-align: right;
    width: 70px;
}
.add_form .value{
    display:inline-block
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
}

.table_searchbar{
    width:100%;
    margin-top: 10px;
    margin-bottom: 20px;
}
.import_upload{
	display: inline;
}
.page{
    display: flex;
    justify-content: flex-end;
}
@media screen and (max-width: 1380px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }
}
.total_page{
    margin-top: 20px;
    margin-right: 26px;
    color:#606266;
    font-size: 14px;
}
</style>
<style>
#chechConf .el-form-item--mini.el-form-item, #chechConf .el-form-item--small.el-form-item{
    margin-top: 8px;
    margin-bottom: 13px;
}
.table_searchbar .el-button--mini, .el-button--mini.is-round {
    padding: 7px 10px;
}
.el-textarea .el-input__count{
    line-height: 12px;
}
.problem .el-input{
    width: 268px;
}
@media screen and (max-width: 1366px){
    .problem .el-input{
        width: 220px;
    }
}

</style>



// WEBPACK FOOTER //
// src/views/devicecare/MaintainConf.vue